import { API, BASE_URL } from '../constants/urls';
import { useMutation, useQueryClient } from '@zg-rentals/react-query5';

export type SendConversationMessagePayload = {
  listingAlias: string;
  textBody: string;
  applicationId: string;
  renterName: string;
};

export type SendConversationMessageResponse = {
  conversationId: string;
};

async function sendConversationMessage(
  requestUrl: string,
  payload: SendConversationMessagePayload,
): Promise<SendConversationMessageResponse> {
  const response = await fetch(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Failed to send conversation message');
  }
  return await response.json();
}

export default function useSendConversationMessage({ onSuccess }: { onSuccess: (conversationId: string) => void }) {
  const queryClient = useQueryClient();
  const requestUrl = `${BASE_URL}${API.SEND_CONVERSATION_MESSAGE}`;
  return useMutation({
    mutationFn: (payload: SendConversationMessagePayload) => sendConversationMessage(requestUrl, payload),
    onSuccess: (response: SendConversationMessageResponse) => {
      onSuccess(response.conversationId);
      queryClient.invalidateQueries({ queryKey: ['getConversationInfoIfExists'] });
    },
  });
}
